<template>
	<v-form ref="unitary_form" @submit="test" onSubmit="return false;">
		<v-layout row justify-center>
			<v-flex>
				<v-card-text class="background darken-1">
					<div class="ml-1 background--text text--lighten-5">
						Référence suifa
					</div>
					<v-text-field
						solo
						class="grv-input"
						:rules="[checkRequired, checkRefSuifa]"
						name="Référence suifa"
						:loading="suifaInfos.loading"
						v-model="form.parameters.suifa_ref"
						@change="getBehiveAssetInfo(form.parameters.suifa_ref)">
						<v-tooltip
							slot="append"
							bottom>
							<v-btn
								@click="getBehiveAssetInfo(form.parameters.suifa_ref)"
								icon
								small
								:disabled="!form.parameters.suifa_ref"
								:loading="suifaInfos.loading"
								slot="activator">
								<v-icon>search</v-icon>
							</v-btn>
							Get data from Behive/Suifa
						</v-tooltip>
					</v-text-field>

					<div v-if="errors">
						<p class="error--text" v-for="error in errors" :key="error.id">
							{{ error }}
						</p>
					</div>

					<table
						v-if="suifaInfos.data && suifaInfos.data.t_aux_proprio"
						class="mt-2 infos-table">
						<tbody>
							<tr v-if="suifaInfos.data.t_aux_proprio.t_libelle ||
												suifaInfos.data.t_aux_proprio.t_auxiliaire">
								<th>Ayant droit</th>
								<td>
									{{ suifaInfos.data.t_aux_proprio.t_libelle }} - ({{ suifaInfos.data.t_aux_proprio.t_auxiliaire }})
								</td>
							</tr>
							<tr>
								<th>Asset</th>
								<td>
									<v-chip
										small label
										class="ml-0"
										color="background lighten-1"
										v-if="suifaInfos.data.type_sup.code_type_sup">
										{{ suifaInfos.data.type_sup.code_type_sup }}
									</v-chip>
									<span v-if="suifaInfos.data.titre.titre_princ">
										{{ suifaInfos.data.titre.titre_princ }}
									</span>
									<strong>
										<span v-if="suifaInfos.data.asset_size &&
																String(suifaInfos.data.asset_size).length < 10">
											- {{ $weight.bitRoundToTwo(suifaInfos.data.asset_size, 2) }} Mo
										</span>
										<span v-else-if="suifaInfos.data.asset_size">
											{{ $weight.bitRoundToTwo(suifaInfos.data.asset_size, 3) }} Go
										</span>
									</strong>
								</td>
							</tr>
							<tr v-if="suifaInfos.data.type_sup.code_type_sup">
								<th>Contrat</th>
								<td>
									<v-icon v-if="localHasContract" color="green accent-3">
										task_alt
									</v-icon>
									<v-icon v-else color="red">block</v-icon>
								</td>
							</tr>
							<tr v-if="suifaInfos.data &&
												suifaInfos.data.cpls &&
												suifaInfos.data.cpls.length > 0">
								<th>Liste des DCP</th>
								<td></td>
							</tr>
							<tr v-for="cpls in suifaInfos.data.cpls" :key="cpls.id">
								<td colspan="2" class="pl-3">
									<v-chip
										label small
										class="mx-0 w-45"
										color="background lighten-1">
										{{ cpls.folder_type }}
									</v-chip>
									{{ cpls.folder_name }}
									<span v-if="cpls.folder_size > 0">
										-
										<span v-if="(String(cpls.folder_size).length < 10)">
											<strong>
												{{ $weight.bitRoundToTwo(cpls.folder_size, 2) }} Mo
											</strong>
										</span>
										<span v-else>
											<strong>
												{{ $weight.bitRoundToTwo(cpls.folder_size, 3) }} Go
											</strong>
										</span>
									</span>
									<span v-else-if="cpls.folder_taille > 0">
										-
										<span v-if="(String(cpls.folder_taille).length < 10)">
											<strong>
												{{ $weight.bitRoundToTwo(cpls.folder_taille, 2) }} Mo
											</strong>
										</span>
										<span v-else>
											<strong>
												{{ $weight.bitRoundToTwo(cpls.folder_taille, 3) }} Go
											</strong>
										</span>
									</span>
								</td>
							</tr>
						</tbody>
					</table>

					<v-layout
						row wrap
						align-end
						v-if="!errors.length && this.suifaInfos.data"
						class="pa-2 mt-4">
						<v-flex shrink>
							<div class="ml-2 background--text text--lighten-5">
								Type de stockage
							</div>
							<v-select
								solo
								dense
								flat
								name="Type de stockage"
								:menu-props="{contentClass: 'grv-menu'}"
								prepend-inner-icon="archive"
								:rules="[checkRequired]"
								class="grv-input"
								:items="storage_list"
								v-model="form.parameters.server_storage">
							</v-select>
						</v-flex>
						<v-flex shrink>
							<v-checkbox
								hide-details
								label="Supprimer la source"
								name="Supprimer la source"
								color="primary"
								class="mb-2 pl-2 grv-input"
								v-model="form.parameters.remove_source">
							</v-checkbox>
						</v-flex>
					</v-layout>
				</v-card-text>
			</v-flex>
		</v-layout>
	</v-form>
</template>

<script>
// 24/10/0138
const REF_SUIFA_REGEXP = /[0-9]{2}\/[0-9]{2}\/[a-zA-Z0-9]{4}/g

export default {
	props: ['wf_data', 'form'],
	data () {
		return {
			storageType: { value: 'catalog', text: 'Catalog' },
			behiveCat: ['hot', 'catalog'],
			ovFolder: '',
			removeSource: false,
			suifaInfos: {
				data: null,
				ref: null,
				loading: false
			},
			localHasContract: false,
			manifest: null,
			jobTypes: ['DCPFOL', 'DCPCOP'],
			errors: [],
			submitLoading: false
		}
	},
	computed: {
		storage_list () {
			if (this.wf_data) {
				let param = this.wf_data.parameters.find(param => {
					return param.name === 'server_storage'
				})
				if (param) return param.choices
			}
			return []
		}
	},

	methods: {
		test () {
			return false
		},
		getTAuxContract (tAux) {
			return new Promise((resolve, reject) => {
				this.$apiPublic.contract_search(tAux)
					.then(response => {
						resolve(response)
					})
					.catch(error => {
						console.error(error)
						reject(error)
					})
			})
		},
		getAssetInfo (ref) {
			return new Promise((resolve, reject) => {
				let params = {
					ref_materiel: ref,
					per_page: 100
				}
				this.$apiPublic.material_search(params, true)
					.then(response => {
						resolve(response)
					})
					.catch(err => {
						console.error(err)
						reject(err)
					})
			})
		},
		async getAlreadyIngestedRef (suifa_ref, category) {
			return new Promise((resolve, reject) => {
				let params = {
					'type_sup_id': 113,
					'suifa_ref': suifa_ref,
					'category': category
				}
				this.$apiPublic.material_search(params)
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						console.error(err)
						reject(err)
					})
			})
		},
		async getBehiveAssetInfo (ref) {
			this.form.parameters.server_storage = this.storage_list[1]
			let refSuifa = (ref || '').replace(/(_|-|\/|\\)/g, '/')
			refSuifa = refSuifa.replace(/(\t|\s+)/g, '')
			this.form.parameters.suifa_ref = refSuifa

			if (refSuifa.match(REF_SUIFA_REGEXP) && this.suifaInfos.ref !== ref) {
				this.suifaInfos.ref = ref
				this.suifaInfos.loading = true
				let hotRef = await this.getAlreadyIngestedRef(refSuifa, 'hot')
				let catalogRef = await this.getAlreadyIngestedRef(refSuifa, 'catalog')
				let jobExists = hotRef.concat(catalogRef)

				if (jobExists.length) {
					// if job exists in maestro
					this.suifaInfos.loading = false
					this.suifaInfos.ref = null
					this.suifaInfos.data = null
					this.errors = [`La référence '${refSuifa}' a déjà été ingestée (ou en cours d'ingest) par Maestro.`]
				} else {
					let activeAssets
					this.getAssetInfo(refSuifa)
						.then(response => {
							activeAssets = response.filter(asset => {
								return this.behiveCat.includes(asset.behive_category)
							})
							// if no active assets
							if (response.length === 0) {
								this.errors = []
								this.manifest = null
								this.errors.push(
									'Pas d\'asset en catalogue ou stockage chaud pour cette référence. ' + `${ref}`
								)
								this.suifaInfos.data = {...response}
								this.suifaInfos.loading = false
								return
							}
							return activeAssets
						})
						.then(response => {
							// reindex asset before getting infos
							return response.map(asset => {
								this.$ApiNexus.reindex_asset(asset.mat_id)
							})
						})
						.then(response => {
							// wait some time because reindex takes time
							return new Promise((resolve) => {
								setTimeout(() => {
									resolve()
								}, 1500)
							})
						})
						.then(response => this.getAssetInfo(refSuifa))
						.then(response => {
							activeAssets = response.filter(asset => {
								return this.behiveCat.includes(asset.behive_category)
							})
							return activeAssets
						})
						.then(response => {
							// if we find active assets
							if (response.length > 0) {
								for (let activeAsset of response) {
									if (this.jobTypes.includes(activeAsset.type_sup.code_type_sup)) {
										this.manifest = null
										this.suifaInfos.data = {...activeAsset}
										this.errors = []
										this.getTAuxContract(this.suifaInfos.data.t_aux_proprio.t_auxiliaire)
											.then(contract => {
												// if client has catalog subscription
												if (contract) {
													if (contract.results.length > 0) {
														let hasContract = contract.results[0].has_storage_catalog
														if (hasContract) {
															this.localHasContract = true
															this.form.parameters.server_storage = this.storage_list[1]
														}
													} else {
														this.localHasContract = false
														this.form.parameters.server_storage = this.storage_list[0]
													}
												}
											})

										break
									} else if (activeAsset.type_sup && !this.jobTypes.includes(activeAsset.type_sup.code_type_sup)) {
										this.errors = []
										this.manifest = null
										this.errors.push(`Type d'asset non pris en charge. (${activeAsset.type_sup.code_type_sup})`)
										this.suifaInfos.data = {...activeAsset}
										this.suifaInfos.loading = false
										// if activeAsset has not cpls array
									} else if (activeAsset.cpls.length < 1) {
										this.errors = []
										this.manifest = null
										this.errors.push('CPLS manquant' + ` (${activeAsset.type_sup.code_type_sup})`)
										this.suifaInfos.data = {...activeAsset}
										this.suifaInfos.loading = false
										// if not in catalog or hot
									}
								}
								this.suifaInfos.loading = false
							// if no active assets
							} else {
								this.errors = []
								this.manifest = null
								this.errors.push(
									'Pas d\'asset en catalogue ou stockage chaud pour cette référence. ' + `${ref}`
								)
								this.suifaInfos.data = null
								this.suifaInfos.loading = false
							}
						})
						.catch(error => {
							console.error(error)
							this.suifaInfos.ref = null
							this.suifaInfos.data = null
							this.suifaInfos.loading = false
						})
				}
			}
		},
		checkRequired (value) {
			if (value === '') return 'Requis'
			if (value === null) return 'Requis'
			if (value === undefined) return 'Requis'
			return true
		},
		checkRefSuifa (value = '') {
			if (value.match(REF_SUIFA_REGEXP)) return true
			return 'ex: 24/05/1839'
		},
		validate () {
			let isValid = this.$refs.unitary_form.validate()
			this.form.isValid = isValid
			return isValid
		},
		resetValidation () {
			return this.$refs.unitary_form.resetValidation()
		}
	}
}
</script>

<style scoped lang="stylus">
.w-45
	min-width: 45px

.infos-table
	th
	td
		padding: 0 4px
		height: 32px
	th
		color: var(--v-primary-base)
		font-weight: normal
</style>



// WEBPACK FOOTER //
// src/pages/maestro/launcher/forms/launcher_form_dcp.vue